import { FEATURE_CODES } from "../../Static/FeatureMapping";

// The module's tab vocabulary and the grant each tab needs.
//
// ITS OWN FILE so that NewWorkOrderPage can ask "may this user open the Assets
// tab?" without importing AssetManagement.jsx, which pulls all three tab
// contents -- the tables, the dialogs, the hooks -- into the work order page's
// bundle for the sake of one lookup table.

// These are SEPARATE grants, not a hierarchy: Casbin dotted codes do not
// inherit, so holding ASSET_MANAGEMENT.WORK_ORDERS gives nothing on
// ASSET_MANAGEMENT.ASSETS. The route itself opens on any one of the three
// (routeFeatureCodes in FeatureMapping); this decides what is inside.
//
// A slug absent from this map is ungated, which keeps a future config-only tab
// working without a code change.
//
// tabsToShow (pageMeta default, orgMeta per-org subset) hides a tab. It does
// NOT deny the endpoints behind it -- a user who holds the feature can still
// reach the API directly. "This org does not use Work Orders" is the right
// use; "this org must not SEE Work Orders" means withholding the grant below
// instead.
export const TAB_FEATURE = {
    network: FEATURE_CODES.ASSET_MANAGEMENT_NETWORK_ENTITIES,
    assets: FEATURE_CODES.ASSET_MANAGEMENT_ASSETS,
    "work-orders": FEATURE_CODES.ASSET_MANAGEMENT_WORK_ORDERS,
};

/**
 * The tab slugs this user's ROLE permits, ignoring org subsetting and config.
 *
 * A cheaper, weaker question than resolveVisibleTabs, for the one caller that
 * cannot afford the strong one: NewWorkOrderPage is a separate route with no
 * pageMeta of its own, and fetching it there purely to decide where a Back
 * button points would put a request on the critical path of raising a work
 * order. usePermissions is context and costs nothing.
 *
 * It is enough for that job. The slug is validated AGAIN on arrival by
 * resolveRequestedTab, which does know tabsConfig and tabsToShow, so a tab this
 * says yes to but the org has hidden still lands on the first visible tab
 * rather than on nothing.
 *
 * hasPermission is passed in rather than read from context so this stays pure.
 * Remember the v1 fallback: it returns true for RBAC v1 orgs, so a v1 org gets
 * every slug and the backend remains the only enforcement.
 */
export const visibleAssetManagementTabSlugs = (hasPermission) => {
    const check = typeof hasPermission === "function" ? hasPermission : () => false;
    return Object.keys(TAB_FEATURE).filter((slug) => check(TAB_FEATURE[slug], "view"));
};

// Which tabs offer "+ New Work Order".
//
// A LIST OF WHAT DOES, not a negation of what does not. "Every tab except
// Network" reads as a special case about Network, and the next tab added
// inherits the action by default -- which is how a button ends up somewhere
// nobody decided to put it. Adding a tab here is a decision; forgetting to is
// the safe outcome.
//
// Network is about managing entities -- who the partners are, where they are,
// what they are called. Moving assets between them is a different job, and the
// button was out of context there.
export const WORK_ORDER_ACTION_TABS = ["assets", "work-orders"];

// Does THIS tab offer the action? The permission gate is separate and sits on
// top: both have to pass, and neither substitutes for the other.
export const tabOffersNewWorkOrder = (slug) =>
    WORK_ORDER_ACTION_TABS.includes(slug);
